export default "__VITE_ASSET__DREDewDY__"